module.exports = __webpack_public_path__ + "static/media/map.bd8f9e29.svg";